import { useAuth } from '../contexts/AuthContext';
import { FrontendFeatureKey, isFrontendFeatureEnabled } from '../utils/frontendFeatures';

/**
 * Leest een feature-flag uit de frontend-settings van de ingelogde gebruiker.
 * Defaults per feature staan centraal in `FRONTEND_FEATURE_DEFAULTS`.
 */
export function useFeature(key: FrontendFeatureKey): boolean {
    const { user } = useAuth();
    return isFrontendFeatureEnabled(user, key);
}

export default useFeature;
